import { useMediaQuery } from 'react-responsive';
import { AdType } from '../../constants/ads';
import AdUnit, { IPresetAdUnitProps } from './AdUnit';

const DESKTOP_AD_QUERY = {
  minWidth: 970
};

const BottomAdUnit: React.FC<IPresetAdUnitProps> = props => {
  const isDesktop = useMediaQuery(DESKTOP_AD_QUERY);

  const adCode = isDesktop
    ? AdType.DesktopLeaderboardBottom
    : AdType.MobileBannerBottom;

  return <AdUnit code={adCode} {...props} />;
};

export default BottomAdUnit;
